export default __webpack_public_path__ + "static/media/20230707191932_IMG_6831 - Bhupeksh _Kaushik.bbcaf682.jpg";